export default "__VITE_PUBLIC_ASSET__2acee3d9__"